<template>
  <svg
    id="list-check"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g>
      <path
        id="Path_7720"
        data-name="Path 7720"
        d="M0,0H18V18H0Z"
        fill="none"
      />
      <path
        id="Path_7721"
        data-name="Path 7721"
        d="M11,12h7.5"
        transform="translate(-2.75 -3)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Path_7722"
        data-name="Path 7722"
        d="M5.561,10.44a1.5,1.5,0,1,1-2.121,0,1.5,1.5,0,0,1,2.121,0"
        transform="translate(-0.75 -2.5)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Path_7723"
        data-name="Path 7723"
        d="M11,5h7.5"
        transform="translate(-2.75 -1.25)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Path_7724"
        data-name="Path 7724"
        d="M3.02,4.131,4.26,5.247,6.755,3"
        transform="translate(-0.755 -0.75)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Path_7725"
        data-name="Path 7725"
        d="M11,19h7.5"
        transform="translate(-2.75 -4.75)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Path_7726"
        data-name="Path 7726"
        d="M5.561,17.44a1.5,1.5,0,1,1-2.121,0,1.5,1.5,0,0,1,2.121,0"
        transform="translate(-0.75 -4.25)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: ["clr"]
};
</script>
